module.exports = __webpack_public_path__ + "img/Inside-sp_13.a5a2c572.jpg";